/**
 * @file カートに入れるボタン表示
 *
 */
'use strict';
import { throttle } from "lodash";

/**
 * @classname ShowCartButtonView
 * @classdesc カートに入れるボタン表示
 */
export default class ShowCartButtonView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ShowCartButtonView.constructor');
		this._$e = $e;
		let $dependencyObj = $('.block-option-select').length ? $('.block-option-select') : $('.block-sku-select');
		document.addEventListener('scroll', throttle(() => {
			$(window).scrollTop() < $dependencyObj.offset().top - 600 ? this._$e.slideUp(150) : this._$e.slideDown(150)
		}, 200), { passive: true });
	};
}
